<template>
    <div class="modal-add-course">
        <div v-if="showModal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Datos del curso</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" @click="toggleModal()">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form action="#" @submit.prevent="submit">
                                    <div class="form-row">
                                        <div class="form-group col-12">
                                            <label for="name" class="col-12 col-form-label text-left">Nombre</label>
                                            <input
                                                id="name"
                                                type="text"
                                                class="form-control"
                                                name="name"
                                                value
                                                required
                                                autofocus
                                                v-model="form.name"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-12">
                                            <label for="entity" class="col-12 col-form-label text-left">Facultad</label>
                                            <input
                                                id="entity"
                                                type="text"
                                                class="form-control"
                                                name="entity"
                                                value
                                                required
                                                autofocus
                                                v-model="form.entity"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-12 col-md-6">
                                            <label for="" class="col-12 col-form-label text-left">Fecha inicio</label>
                                            <datepicker :language="es" :input-class="inputClass" v-model="form.startDate" :required="true" format="d MMMM yyyy"></datepicker>
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <label for="" class="col-12 col-form-label text-left">Fecha fin</label>
                                            <datepicker :language="es" :input-class="inputClass" v-model="form.endDate" :required="true" format="d MMMM yyyy"></datepicker>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-12 col-md-6">
                                            <label for="entity" class="col-12 col-form-label text-left">Tipo</label>
                                            <select v-model="form.type" class="form-control" required>
                                                <option disabled value="">Seleccionar uno...</option>
                                                <option>Congreso</option>
                                                <option>Certificación</option>
                                                <option>Curso</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <label for="maxCert" class="col-12 col-form-label text-left">Máx. diplomas</label>
                                            <input
                                                id="maxCert"
                                                type="number"
                                                class="form-control"
                                                name="maxCert"
                                                value
                                                required
                                                autofocus
                                                v-model="form.maxCert"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-12 col-md-6">
                                            <label for="effort" class="col-12 col-form-label text-left">Esfuezo (horas)</label>
                                            <input
                                                id="effort"
                                                type="number"
                                                class="form-control"
                                                name="effort"
                                                min="0"
                                                value
                                                autofocus
                                                v-model="form.effort"
                                            />
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <label for="courseId" class="col-12 col-form-label text-left">Código curso</label>
                                            <input
                                                id="courseId"
                                                type="number"
                                                class="form-control"
                                                name="courseId"
                                                value
                                                required
                                                autofocus
                                                v-model="form.courseId"
                                            />
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <label for="template" class="col-12 col-form-label text-left">Templates</label>
                                            <select v-model="form.template" class="form-control" required>
                                                <option disabled value="">Seleccionar uno...</option>
                                                <option value="default">default</option>
                                                <option value="1">Galileo-GIZ</option>
                                                <option value="2">PROFXXI</option>
                                                <option value="3">GES - 2023</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-12 col-md-12">
                                          <label for="templateEmail" class="col-12 col-form-label text-left">Plantilla de correo</label>
                                          <div class="info-email ml-3 text-secondary font-size-11px" style="font-size: 12px;">
                                            <p class="mb-0">Ayuda para envio de correo:</p>
                                            <ul>
                                              <li>{email}: Reemplazará el email del curso en la plantilla del correo.</li>
                                              <li>{nombre}: Reemplazará el nombre de la persona en el diploma.</li>
                                              <li>{apellido}: Reemplazará el apellido de la persona en el diploma.</li>
                                              <li>{curso}: Cambiará el texto por el nombre del curso en el cual ser dió el diplima.</li>
                                              <li>{link}: Será el link para que el usuario pueda ver sus resultados.</li>
                                              <li>{link_firma}: Cambiará el link para poder descargar la firma del diploma.</li>
                                              <li>{link_pdf}: Cambiará el link para poder descargar el diploma.</li>
                                            </ul>
                                          </div>
                                          <!-- <textarea class="form-control w-100" v-model="form.templateEmail" name="templateEmail" id="templateEmail" cols="30" rows="10"></textarea> -->
                                          <editor
                                            api-key="no-api-key"
                                            v-model="form.templateEmail"
                                            plugins="lists code"
                                            :init="{
                                              height: 500
                                            }"
                                          />
                                        </div>
                                    </div>

                                    <div class="form-group row mt-4">
                                        <div class="col-12 text-center">
                                            <button v-if="actionBtn =='add'" type="submit" class="btn btn-primary">Guardar</button>
                                            <span v-if="actionBtn =='update'" @click="updateCourse(courseData.id)" class="btn btn-primary">Actualizar</span>
                                            <span v-if="actionBtn =='update'" @click="toggleModal()" class="btn btn-outline-primary">Cancelar</span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import firebase from "firebase/app"
import 'firebase/firestore'
import 'firebase/storage'
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js"
import { es } from "vuejs-datepicker/src/locale"
import Editor from '@tinymce/tinymce-vue'

export default {
    name: "ModalAddCourse",
    computed: {
        showModal() {
            return this.$store.getters.addCourseShow
        },
        courseAction() {
            return this.$store.getters.getCourseAction
        },
        courseData() {
            return this.$store.getters.getCourseData
        },
        actionTrigger() {
            return this.$store.getters.courseActionTrigger
        },
    },
    watch: {
        actionTrigger: function(newVal, oldVal) {
            if (this.courseAction == 'edit') {
                this.actionBtn = "update"
                this.form.name = (this.courseData.name) ? this.courseData.name : ""
                this.form.entity = (this.courseData.entity) ? this.courseData.entity : ""
                this.form.type = (this.courseData.type) ? this.courseData.type : ""
                this.form.effort = (this.courseData.effort) ? this.courseData.effort : ""
                this.form.maxCert = (this.courseData.maxCert) ? this.courseData.maxCert : ""
                this.form.courseId = (this.courseData.courseId) ? this.courseData.courseId : ""
                this.form.startDate = (this.courseData.startDate) ? this.timeConverter(this.courseData.startDate) : ""
                this.form.endDate = (this.courseData.endDate) ? this.timeConverter(this.courseData.endDate) : ""
                this.form.template = (this.courseData.template) ? this.courseData.template : "default"
                this.form.templateEmail = (this.courseData.templateEmail) ? this.courseData.templateEmail : "";
            }
        }
    },
    data() {
        return {
            form: {
                name: "",
                entity: "",
                type: "",
                effort: 0,
                maxCert: "",
                courseId: "",
                startDate: "",
                endDate: "",
                template: "",
                templateEmail: ""
            },
            actionBtn: "add",
            es: es,
            inputClass: "form-control"
        }
    },
    methods: {
        async submit() {
            let coursesRef = await firebase.firestore().collection("courses")

            coursesRef.add({
                    name: this.form.name,
                    entity: this.form.entity,
                    type: this.form.type,
                    effort: this.form.effort,
                    maxCert: this.form.maxCert,
                    emitedCert: 0,
                    courseId: this.form.courseId,
                    startDate: this.form.startDate,
                    endDate: this.form.endDate,
                    template: this.form.template,
                    status: 1,
                    templateEmail: this.form.templateEmail,
                    createdAt: new Date()
                })

            this.toggleModal()
            this.$toasted.show('Datos del curso guardados')
        },
        toggleModal() {
            this.form.name = ''
            this.form.entity = ''
            this.form.type = ''
            this.form.effort = ''
            this.form.maxCert = ''
            this.form.courseId = ''
            this.form.startDate = ''
            this.form.endDate = ''
            this.actionBtn = "add"
            this.form.template = ""
            this.form.templateEmail = ""
            this.$store.dispatch("toggleModalAddCourse")
        },
        updateCourse(docId) {
            firebase
                .firestore()
                .collection("courses")
                .doc(docId)
                .update({
                    name: this.form.name,
                    entity: this.form.entity,
                    type: this.form.type,
                    effort: this.form.effort,
                    maxCert: this.form.maxCert,
                    courseId: this.form.courseId,
                    startDate: this.form.startDate,
                    templateEmail: this.form.templateEmail,
                    endDate: this.form.endDate
                })
            this.toggleModal()
            this.$toasted.show('Curso actualizado')
        },
        timeConverter(datetimestamp){
            let dateVar = new Date(datetimestamp.seconds * 1000)
            let year = dateVar.getFullYear()
            let month = dateVar.getMonth()+1
            let date = dateVar.getDate()
            let time = month + ' ' + date + ' ' + year
            return time
        }
    },
    components: {
        Datepicker,
        'editor': Editor
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    -webkit-transition: opacity 500ms ease-in;
    -moz-transition: opacity 500ms ease-in;
    transition: opacity 500ms ease-in;
    overflow: auto;
}
.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}
.modal-header {
    background-color: #007bff;
    color: #fefefe;
}
.modal-header span {
    color: #fefefe;
}
.modal-body {
  max-height: calc(100vh - 210px);
  overflow-y: auto;
}
.form-group {
    margin-bottom: 0 !important;
}
</style>

<style>
.tox.tox-silver-sink.tox-tinymce-aux{
  z-index: 999999;
}
.tox-menu.tox-collection.tox-collection--list.tox-selected-menu {
  z-index: 99999999999;
}
.tox-notifications-container{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ModalAddCourse.vue